import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Users, CalendarClock } from "lucide-react";

const fmt = (d) => (d ? d.split("-").reverse().join("/") : "—");

// Home: "Task condivisi con te" (sostituisce la card Azioni).
export default function AzioniHomeCard() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/attivita/condivisi-con-me").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r || !r.length) return null;
  return (
    <div data-testid="home-task-condivisi" className="card-immo p-4 mb-4">
      <div className="flex items-center gap-2 font-display font-bold mb-2"><Users size={18} className="text-[#FC82ED]" /> Task condivisi con te <span className="mono text-xs text-[var(--muted)]">{r.length}</span></div>
      <div className="divide-y divide-[var(--border)]">{r.slice(0, 6).map((t) => (
        <Link key={t.id} to={`/task?t=${t.id}`} data-testid={`home-task-condiviso-${t.id}`} className="flex items-center gap-3 py-2 text-sm hover:bg-slate-50 rounded-lg px-1">
          <span className="flex-1 min-w-0"><b className="block truncate">{t.titolo}</b><span className="text-[11px] text-[var(--muted)]">Condiviso da {t.condiviso_da || "—"}{t.assegnato_a ? ` · assegnato a ${t.assegnato_a}` : ""}</span></span>
          <span className={`text-xs inline-flex items-center gap-1 ${t.scadenza && t.scadenza < new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" }) ? "text-red-600 font-semibold" : "text-[var(--muted)]"}`}><CalendarClock size={12} /> {fmt(t.scadenza)}</span>
        </Link>))}</div>
      {r.length > 6 && <Link to="/task" className="text-xs font-semibold text-[#B8369F] hover:underline">Vedi tutti</Link>}
    </div>
  );
}
